<template>
  <div class="layout">
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from '@/components/header'
export default {
  name: 'Layout',
  components: {
    Header
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');
  .layout {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background-color: var(--background-color, @background-color);
  }
</style>